import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { Field, reduxForm, reset } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import Panel from 'react-bootstrap/lib/Panel';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';

import Link from '../../Link';
import AdminStarRating from '../AdminStarRating';
import InputFieldComponent from '../../Common/FormField/InputFieldComponent';

import WriteAdminReviewMutation from './WriteAdminReviewMutation.graphql';
import history from '../../../core/history';
import messages from '../../../locale/messages';
import showToaster from '../../../helpers/showToaster';
import { withMutation } from '../../../hoc/withGraphql';
import validate from './validate';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

import s from './AdminReviewsForm.css';
import bt from '../../../components/commonStyle.css';
class AdminReviewsForm extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    initialValues: PropTypes.object,
  };

  renderStarRating = ({ input, label, meta: { touched, error }, className, children }, value) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={bt.space4}>
        <label className={s.labelTextNew} >{label}</label>
        <AdminStarRating
          name={input.name}
          change={input.onChange}
          value={input.value}
          editing={true}
          className={cx(s.adminReviewStar, 'reviewStarAlign')}
        />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </FormGroup>

    )
  }

  submitForm = async (values, dispatch) => {
    const { mutate, demoRestriction } = this.props;

    let listId = Number(values?.listId);
    let variables = Object.assign({}, values, { listId });

    const isRestrict = await demoRestriction({});
    if (isRestrict) return;

    const { data } = await mutate({
      variables
    });
    if (data?.writeAdminReview) {
      if (data?.writeAdminReview?.status === '200') {
        showToaster({
          messageId: 'writeAdminReview',
          toasterType: 'success',
          requestContent: values.id
        })

        !values.id && dispatch(reset('AdminReviewsForm'));

      } else if (data.writeAdminReview.status === '404') {
        return showToaster({ messageId: 'invalidId', toasterType: 'error' })
      } else if (data.writeAdminReview.status === '500') {
        return showToaster({ messageId: 'adminReviewError', toasterType: 'error' })
      } else {
        return showToaster({ messageId: 'userReviewError', toasterType: 'error' })
      }
      history.push('/siteadmin/reviews')
    }
  }

  render() {
    const { error, handleSubmit, submitting, initialValues } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <Grid fluid>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <h1 className={s.siteAdminHeading}> <FormattedMessage {...messages.writeReviwes} /></h1>
          </Col>
          <Col xs={12} sm={12} md={9} lg={8} className={s.blockCenter}>
            {initialValues &&
              <div className={cx(s.space4, 'singleButtonFlexEnd')}>
                <Link to={'/siteadmin/reviews'} className={cx(bt.btnPrimaryBorder, bt.btnLarge, bt.noTextDecoration)}>
                  <FormattedMessage {...messages.goBack} />
                </Link>
              </div>
            }
            <Panel className={cx(s.panelHeader)}>
              <form onSubmit={handleSubmit(this.submitForm)}>
                {error && <strong>{error}</strong>}
                <Field name="listId"
                  type="text"
                  component={InputFieldComponent}
                  label={formatMessage(messages.listId)}
                  inputClass={bt.commonControlInput}
                  formGroupClass={bt.space4}
                  placeholder={formatMessage(messages.listIdPlaceHolder)}
                />
                <Field name="reviewContent"
                  component={InputFieldComponent}
                  inputClass={bt.commonControlTextArea}
                  label={formatMessage(messages.reviewContentLabel)}
                  componentClass={'textarea'}
                  formGroupClass={bt.space4}
                  placeholder={formatMessage(messages.reviewContentPlaceHolder)}
                />
                <Field name="rating"
                  component={this.renderStarRating}
                  label={formatMessage(messages.reviewRating)} />

                <div className='singleButtonFlexEnd'>
                  <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting} >
                    <FormattedMessage {...messages.submitLabel} />
                  </Button>
                </div>
              </form>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

AdminReviewsForm = reduxForm({
  form: 'AdminReviewsForm', // a unique name for this form
  validate
})(AdminReviewsForm);

const mapState = (state) => ({});

const mapDispatch = {
  demoRestriction
};


export default compose(injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  withMutation(WriteAdminReviewMutation)
)(AdminReviewsForm);